import React from 'react';
// eslint-disable-next-line no-unused-vars
import * as FxLog from '../../fx/FxLog';
import * as FxFetch from '../../fx/FxFetch';
import * as FxDat from '../../fx/FxDat';
import * as FxTable from '../../fx/FxTable';
import { useTranslation } from '../../hx/useTranslation';
import CxDialog from '../../cx/CxDialog';
import CxChooser from '../../cx/CxChooser';
import CxNumber from '../../cx/CxNumber';
import CxSearcher from '../../cx/CxSearcher';
import CxStatic from '../../cx/CxStatic';
import CxSnackbar from '../../cx/CxSnackbar';
import '../../../styles/main.css';
import { useSessionStorage } from '../../hx/useSessionStorage';
import { StoreStock } from "../../gx/GxStore";


const MxStockroomListTransferDlg = (props) => {
  const [{ trans }] = useTranslation();
  const [dlg, setDlg] = React.useState(false);
  const { onOk, } = props;

  const [showLotSearcher, setShowLotSearcher] = React.useState(true);
  
  const rf_txBranch_from = React.useRef(null);
  const rf_txBranch_to = React.useRef(null);
  const rf_txLotCode = React.useRef(null);
  const rf_nuStock = React.useRef(null);

  const r_snack_required = React.useRef(null);
  const r_snack_op_successful = React.useRef(null);
  const r_snack_error = React.useRef(null);

  const [storeStock, setStoreStock] = useSessionStorage('StoreStock', StoreStock);

  const [disabled, setDisabled] = React.useState(false);
  
  React.useEffect(() => {
    formLoad();

    return () => {
    }
    // eslint-disable-next-line
  }, []);

  // Se ejecuta cada vez que el diálogo se abre o se cierra
  React.useEffect(() => {
    if (dlg) {
      // Un pequeño delay con setTimeout asegura que el DOM interno de CxDialog y CxSearcher ya terminó de dibujarse
      setTimeout(() => {
        checkLotsAvailability();
      }, 50);
    }
    // eslint-disable-next-line
  }, [dlg]);

  const checkLotsAvailability = async () => {
    try {
      let record = {};
      record['searchText'] = '';
      record['pageNo'] = 0;
      record['pageSize'] = 1; // Solo necesitamos saber si trae al menos un registro
      record['filter'] = `n_pur_invoice_item.inPs='${storeStock.inPs}'`;

      // Consultamos directamente al endpoint del servidor
      const result = await FxFetch.doJsonX(`sls/docitem/lots`, record);
      
      if (result && Array.isArray(result) && result.length > 0) {
        setShowLotSearcher(true);
      } else {
        setShowLotSearcher(false);
      }
    } catch (error) {
      FxLog.errorx("MxStockroomListTransferDlg.checkLotsAvailability", error);
      setShowLotSearcher(false);
    }
  };

  // para poder usar setVal desde el parent component con ref.current
  React.useImperativeHandle(props.xref, () => {
    return {
      setDlg, setStoreStock,
    };
  });

  const formLoad = async () => {
  }
  const formSave = async () => {
    // chequea requeridos
    if (rf_txBranch_from.current.isEmpty()) {
      r_snack_required.current.setVal(trans('field.required') + ": " + rf_txBranch_from.current.getLabel());
      r_snack_required.current.setOpen(true);
      return;
    }
    if (rf_txBranch_to.current.isEmpty()) {
      r_snack_required.current.setVal(trans('field.required') + ": " + rf_txBranch_to.current.getLabel());
      r_snack_required.current.setOpen(true);
      return;
    }
    if (showLotSearcher) {
      if (rf_txLotCode.current.isEmpty()) {
        r_snack_required.current.setVal(trans('field.required') + ": " + rf_txLotCode.current.getLabel());
        r_snack_required.current.setOpen(true);
        return;
      }
    }
    if (rf_nuStock.current.isEmpty()) {
      r_snack_required.current.setVal(trans('field.required') + ": " + rf_nuStock.current.getLabel());
      r_snack_required.current.setOpen(true);
      return;
    }

    localStorage.setItem('MxStockroomListTransferDlg.from', `${rf_txBranch_from.current.getKey()}|${rf_txBranch_from.current.getVal()}`);
    localStorage.setItem('MxStockroomListTransferDlg.to', `${rf_txBranch_to.current.getKey()}|${rf_txBranch_to.current.getVal()}`);

    let record = {};
    record['dtTransfer'] = FxDat.timestamp();
		record['inPs'] = storeStock.inPs;
		record['txPs'] = storeStock.txPs;
		record['nuStock'] = rf_nuStock.current.getVal();
		record['inBranchFrom'] = rf_txBranch_from.current.getKey();
		record['inBranchTo'] = rf_txBranch_to.current.getKey();
    if (showLotSearcher) {
      record['txLotCode'] = rf_txLotCode.current.getRow().original.txLotCode;
      record['dtLotExpr'] = rf_txLotCode.current.getRow().original.dtLotExpr;
    }
		record['txRemarks'] = '';
    Promise.all([FxFetch.doJsonX(`stock/transfer`, record)]).then((result) => {
      if (result[0]) {
        if (result[0].theValue === 'OK') {
          setDisabled(true);
          r_snack_op_successful.current.setOpen(true);
        }
      }
    });
  }

  return (
    <div>
      <CxDialog title={trans('field.transfer_between_x', 'field.branches')} open={dlg} onOk={formSave} disabled={disabled} onCancel={() => setDlg(false)} >

        <CxStatic label={`${storeStock.txPs || ''}`} border='none' fontcolor='var(--ibs_color_blue)' fontsize='12px' width='var(--ibs_control_width_md)' />

        <CxChooser xref={rf_txBranch_from}
          label={trans('field.from_x', 'field.branch')}
          id="n_branch"
          table="n_branch"
          col_id="inBranch"
          col_tx="txBranch"
          extra_filter_1={"boActive='1'"}
          defaultKeyAndValue={localStorage.getItem('MxStockroomListTransferDlg.from')||''}
          disabled={disabled}
          required
        />

        <CxChooser xref={rf_txBranch_to}
          label={trans('field.to_x', 'field.branch')}
          id="n_branch"
          table="n_branch"
          col_id="inBranch"
          col_tx="txBranch"
          extra_filter_1={"boActive='1'"}
          defaultKeyAndValue={localStorage.getItem('MxStockroomListTransferDlg.to')||''}
          disabled={disabled}
          required
        />

        {showLotSearcher && <CxSearcher 
          xref={rf_txLotCode}
          label={trans('field.lot')}
          url="sls/docitem/lots"
          filter={`n_pur_invoice_item.inPs='${storeStock.inPs}'`} // Valor inicial (asumiendo check en false)
          col_id="inPurInvoiceItem"
          col_tx="txLotCode"
          refColors={[ 'table_cell_color_gray|' + trans('field.expired'), 'table_cell_color_red|' + trans('field.sold_out') ]}
          columns={[
            { id: "0", Header: "ID", accessor: "inPurInvoiceItem", show: false },
            { id: "1", Header: trans('field.lot'), accessor: "txLotCode", width: '35%' },
            { id: "2", Header: trans('field.expiration'), accessor: row => FxTable.cellToLocalDate(row["dtLotExpr"]), width: '35%' },
            { id: "3", Header: trans('field.quantity'), accessor: "nuQuantity", width: '30%', align: 'center' },
            { id: "A", Header: "_expired", accessor: row => FxDat.isExpired(row["dtLotExpr"]), show: false },
            { id: "R", Header: "_sold_out", accessor: row => Boolean(row["nuQuantity"] < 1), show: false },
          ]}
          required
        />}

        <CxNumber xref={rf_nuStock}
          label={`${trans('field.stock')}`}
          decimals={2}
          decimalsfixed="true" 
          autoselect="true"
          defaultValue="1"
          sumButton
          disabled={disabled}
          required
        />

      </CxDialog>

      <CxSnackbar xref={r_snack_required} severity="error" />
      <CxSnackbar xref={r_snack_error} severity="error" />
      <CxSnackbar xref={r_snack_op_successful} severity="success" value={trans('msg.operation_successful')} onClose={() => { 
        if (onOk) {
          Promise.all([setDlg(false)]).then((result) => {
            setDisabled(false);
            onOk(); 
          });
        }
      }} />

    </div>
  );

}

export default MxStockroomListTransferDlg;
